import Link from 'next/link';
import React from 'react';

const posts = [
  {
    href: 'https://www.onairparking.com/blog/travel/skip-the-panic-real-time-tsa-wait-times-to-perfect-your-travel-schedule/',
    title: 'Skip the Panic: Real-Time TSA Wait Times to Perfect Your Travel Schedule'
  },
  {
    href: 'https://www.onairparking.com/blog/travel/how-affiliates-can-earn-money-with-onair-parkings-affiliate-program/',
    title: 'How Affiliates Can Earn Money with OnAir Parking’s Affiliate Program'
  },
  {
    href: 'https://www.onairparking.com/blog/travel/on-air-parking-and-kayak-partner-to-simplify-affordable-travel/',
    title: 'On Air Parking and Kayak Partner to Simplify Affordable Travel'
  }
];

export default function BlogPost() {
  return (
    <div className="w-full bg-white">
      <div className="mx-auto space-y-6 max-w-7xl px-4 md:px-32 xl:px-4 py-16">
        <h3 className="text-3xl font-bold text-center">From the Blog</h3>
        <div className="flex flex-col md:flex-row w-full gap-6 justify-center items-stretch">
          {posts.map((post, index) => (
            <div
              key={index}
              className="flex flex-col border border-gray-200 rounded-lg p-6 shadow-sm w-full text-start items-start"
            >
              <p className="text-base text-gray-800 font-semibold mb-4">{post.title}</p>
              <Link
                href={post.href}
                target="_blank"
                rel="noopener noreferrer"
                type='primary'
                className="inline-block font-light hover:text-primary hover:underline"
              >
                Read More
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
